export default __webpack_public_path__ + "static/media/dansketext-semibold.8db192c2.woff";